import traceUFOTransition from '@atlassian/react-ufo/trace-transition';
export { useUFOTransitionCompleter } from '@atlassian/react-ufo/trace-transition';
export default traceUFOTransition;